import React from 'react';
import styled from 'styled-components';

const StatusBadge = ({ status, children }) => {
    return (
        <BadgeContainer status={status}>
            {children || status}
        </BadgeContainer>
    );
};

const BadgeContainer = styled.span`
    display: flex;
    padding: 2px 8px;
    align-items: center;
    border-radius: 9999px;
    border: 1px solid ${(props) => {
        switch (props.status) {
            case 'Active':
                return '#ABEFC6';
            case 'Inactive':
            case 'Deactivated':
                return '#E5E7EB';
            default:
                return '#E5E7EB';
        }
    }};
    background: ${(props) => {
        switch (props.status) {
            case 'Active':
                return '#ECFDF3';
            case 'Inactive':
            case 'Deactivated':
                return '#F9FAFB';
            default:
                return '#F9FAFB';
        }
    }};
    color: ${(props) => {
        switch (props.status) {
            case 'Active':
                return '#067647';
            case 'Inactive':
            case 'Deactivated':
                return '#374151';
            default:
                return '#374151';
        }
    }};
    text-align: center;
    font-family: Inter;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
`;

export default StatusBadge;

